import { render } from "./PromoCodeDetail.vue?vue&type=template&id=20d25329&scoped=true"
import script from "./PromoCodeDetail.vue?vue&type=script&lang=js"
export * from "./PromoCodeDetail.vue?vue&type=script&lang=js"

import "./PromoCodeDetail.vue?vue&type=style&index=0&id=20d25329&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d25329"]])

export default __exports__